// extracted by mini-css-extract-plugin
export default {"upload-area":"UploadCon_upload-area__G2oO-","has-img":"UploadCon_has-img__rULL0"};